export default __webpack_public_path__ + "static/media/arrow-left-circle.add1df5c.svg";